/**
 * Load more functionality for articles.
 */
const loadMore = {

  init: function() {
    const $ = window.$ || window.jQuery;

    $(document).on('click', '.load-more', function() {
      const $button = $(this);
      const $target = $('#' + $button.data('container'));
      const oldText = $button.text();
      $target.addClass('loading');
      $button.addClass('loading');
      $button.prop('disabled', true);
      $button.text($button.data('loading-text'));
      $.ajax({
        url: '/stage-ajax/articles/',
        data: {
          'stage-language': document.documentElement.lang,
          type: $button.data('type'),
          page: $button.data('page'),
        }
      }).always(function(response) {
        $target.removeClass('loading');
        $button.removeClass('loading');
        $button.prop('disabled', false);
        if (!response || !response.totalCount) {
          $button.text(oldText);
          return;
        }

        if (response.html) {
          $target.append(response.html);
        }

        if (response.itemsLeft <= 0) {
          $button.remove();
        }
        else {
          $button.text($button.data('text').replace('%n%', response.itemsLeft));
        }
      });
    });
  }

};

export default loadMore;
